<template>
  <modal :title="$t(Dtitle)" :visible.sync="isShowDialog" width="1000px">
    <div class="iconClass" v-show="ismode">
      <i class="el-icon-edit" :title="$t('public.mode_edit')" @click="modeEditFn('edit')"></i>
    </div>
    <el-form v-show="ismode" ref="form" class="content" label-width="160px" :model="dioForm">
      <div class="leftContent">
        <el-form-item :label="$t('user.role_name')" prop="name">
          <span>
            {{ detailObj.name }}
          </span>
        </el-form-item>
        <el-form-item :label="$t('user.type')" prop="type">
          <span>
            {{ changeType(detailObj.type) }}
          </span>
        </el-form-item>
        <el-form-item :label="$t('user.status')" prop="status">
          <span>
            {{ this.$t(detailObj.status === 1 ? 'public.role_status_activity' : 'public.role_status_cancel') }}
          </span>
        </el-form-item>
        <template v-if="$store.state.type === 3 || $store.state.type === 2">
          <el-form-item :label="$t('user.belonging')" prop="customerId" v-if="!isProxyType">
            <span>
              {{ customerFn(detailObj.customerId) }}
            </span>
          </el-form-item>
        </template>
        <el-form-item :label="$t('user.proxy_customer')" prop="customerIds" v-if="isProxyType">
          <div style="max-height: 300px;overflow-y: auto;" class="w-100">
            <div class="proxyClass" :title="item.name" @click="handleProxy(index)"
              :class="index === active ? 'active' : 'border'" v-for="(item, index) in detailObj.proxy" :key="item.id">
              {{ item.name }}
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('user.remarks')" prop="remark">
          <span>
            {{ detailObj.remark }}
          </span>
        </el-form-item>
      </div>
      <div class="rightContent">
        <el-form-item :label="$t('user.resource')" prop="page">
          <div class="treeClass" v-loading="detailTreeLoadChildren">
            <el-tree :key="$i18n.locale" :props="props" :data="resoureTree" :render-content="renderContent" ref="tree">
            </el-tree>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <publicContent v-show="!ismode" ref="PublicContent" :ismode.sync="ismode" v-bind="$attrs" @concatFn="concatFn"
      :treeLoading="treeLoading" :customerAddArray="customerAddArray" :editObj="editObj" :editTree="editTree" />
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false">{{
        $t('public.btn_close')
      }}</el-button>
      <el-button type="primary" v-show="!ismode" @click="handleSave">{{
        $t('public.btn_apply')
      }}</el-button>
    </div>
    <ConcatDialog :total="total" :tableData="tableData" :concatShow.sync="concatShow" :concatTilte="concatTilte"
      :loading="loading" @getListFn="getConcatFn" />
  </modal>
</template>

<script>
import {
  roleUser,
  roleCustomer,
  roleResource,
  roleEdit,
} from '@/api/modules/role.js'

import ConcatDialog from './ConcatDialog.vue'
import publicContent from './rolePublic.vue'
export default {
  props: ['title', 'isShowDetail', 'detailObj', 'detailTreeLoad', 'detailTree'],
  components: {
    ConcatDialog,
    publicContent,
  },
  watch: {
    detailObj(newVal) {
      this.editObj = { ...newVal }
      // 是否为代理
      if (newVal.type === -1) {
        this.isProxyType = true
      } else {
        this.isProxyType = false
      }
    },
    detailTree(newVal) {
      this.resoureTree = [...newVal] || []
    },
    ismode(bool) {
      !bool ? (this.Dtitle = this.$t("user.role_edit")) : (this.Dtitle = this.$t("user.role_info"))
    },
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowDetail
      },
      set: function (val) {
        this.$emit('update:isShowDetail', val) //可以优化成model  或者minx
      },
    },
    detailTreeLoadChildren: {
      get: function () {
        return this.detailTreeLoad
      },
      set: function (val) {
        this.$emit('update:detailTreeLoad', val) //可以优化成model  或者minx
      },
    },
  },
  data() {
    return {
      dioForm: {},
      Dtitle: this.$t("user.role_info"),
      ismode: true,
      isProxyType: true,
      resoureTree: [],
      active: 0,
      // 联系人
      concatTilte: '',
      concatShow: false,
      props: {
        label: 'label',
        children: 'item',
      },
      // 联系人
      total: 0,
      tableData: [],
      query: {
        name: null,
        iDisplayStart: 0,
        iDisplayLength: 15,
      },
      loading: false,
      // 编辑
      editObj: {},
      customerAddArray: [],
      editTree: [],
      treeLoading: false,
    }
  },
  methods: {
    modeEditFn() {
      this.ismode = !this.ismode
      this.treeLoading = true
      roleCustomer({ type: this.detailObj.type }).then(({ result }) => {
        this.customerAddArray = result || []
      })
      let query = {
        id: this.detailObj.id || null,
        type: this.detailObj.type,
        isEdit: 1,
      }
      roleResource(query)
        .then(({ result }) => {
          this.editTree = result.item || []
        })
        .finally(() => {
          this.treeLoading = false
        })
    },
    proxyFn(array = []) {
      return array.map((item) => item.name).join(',')
    },
    handleProxy(index) {
      this.active = index
      // 假调用 因为代理的资源都是一样的
      this.detailTreeLoadChildren = true
      let query = {
        id: this.detailObj.id || null,
        type: this.detailObj.type,
        isEdit: 0,
      }
      roleResource(query)
        .then(({ result }) => {
          this.resoureTree = result.item || []
        })
        .finally(() => {
          this.detailTreeLoadChildren = false
        })
    },
    customerFn(customerId) {
      let str = ''

      for (let item of this.$attrs.customerAddArray) {
        if (item.id === customerId) {
          str = item.name
          break
        }
      }
      return str
    },
    changeType(typeId) {
      let str = ''

      for (let item of this.$attrs.roleTypeArray) {
        if (item.value === typeId) {
          str = this.$t(item.label)
          break
        }
      }
      return str
    },

    concatFn() {
      this.concatShow = true
      this.concatTilte = this.detailObj.name + ' ' + this.$t("user.user")
      this.getConcatFn()
    },
    getConcatFn(name) {
      this.loading = true
      this.query.id = this.detailObj.id
      this.query.name = name || null
      roleUser(this.query)
        .then(({ result }) => {
          this.total = result.pageInfo.total
          this.tableData = result.result
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 保存
    async handleSave() {
      let falg = await this.$refs['PublicContent'].justify()
      if (!falg) return
      let dioForm = this.$refs['PublicContent'].dioForm
      if (dioForm.type === -1) {
        dioForm.customerIds = this.$refs['PublicContent'].customerIdArray.map(
          (item) => item.customerIds
        )
      } else {
        dioForm.customerIds = ''
      }
      for (let key in dioForm) {
        if (dioForm[key] === '') {
          delete dioForm[key]
        }
      }
      roleEdit(dioForm).then(({ result, state }) => {
        if (result === 200) {
          this.isShowDialog = false
          this.$message.success(this.$t("user.user_edit_code_200"))
          this.$parent.getListFn()
        } else if (result === 405) {
          this.$message.error(this.$t("user.role_edit_code_405"))
        } else if (result === 406) {
          this.$message.error(this.$t("user.role_edit_code_406"))
        } else if (result === 407) {
          this.$message.error(this.$t("user.role_edit_code_407"))
        } else if (result === 408) {
          this.$message.error(this.$t("user.role_edit_code_408"))
        } else if (result === 409) {
          this.$message.error(this.$t("user.role_edit_code_409"))
        } else if (result === 410) {
          this.$message.error(this.$t("user.role_edit_code_410"))
        } else if (result === 411) {
          this.$message.error(this.$t("user.role_edit_code_411"))
        } else if (result === 412) {
          this.$message.error(this.$t("user.role_edit_code_412"))
        } else if (result === 413) {
          this.$message.error(this.$t("user.role_edit_code_413"))
        } else if (result === 415) {
          this.$message.error(this.$t("user.role_edit_code_415"))
        } else {
          this.$message.error(this.$t("user.role_edit_code_500"))
        }
      })
    },
    renderContent() {
      let createElement = arguments[0]
      let data = arguments[1].data
      let isZh = (this.$i18n.locale || '').indexOf('zh') === 0
      // 动态菜单节点直接使用 DB 中的本地化名称，兜底到 label（code）
      let displayName = isZh ? (data.nameZh || data.label) : (data.nameEn || data.label)
      return createElement('span', displayName)
    },
  },
}
</script>

<style lang="scss" scoped>
.iconClass {
  height: 30px;
  line-height: 30px;
  text-align: right;

  i {
    margin: 0 5px;
    cursor: pointer;

    &:hover {
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.content {
  width: 100%;
  height: 650px;
  display: flex;

  .proxyClass {
    margin-right: 5px;
    display: inline-block;
    height: 30px;
    line-height: 30px;
    width: 150px;
    border-radius: 2px;

    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;

    text-align: center;

    &:not(:first-child) {
      margin-top: 15px;
    }

    i {
      margin: 0 5px;
      cursor: pointer;
      font-weight: bold;
    }
  }

  .active {
    background-color: var(--primary-color);
    color: #fff;
    font-weight: bold;
  }
}

.leftContent,
.rightContent {
  flex: 1;

  .treeClass {
    height: 600px;
    overflow: auto;
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    border: 1px solid #e7e7e7;
  }
}
</style>